angular.module('List').filter("trust", ['$sce', function($sce) {
    return function(htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    };
}]);

angular.module('List').controller('CategoryListController', [
    '$scope',
    '$filter',
    '$sce',
    '$timeout',
    'DataService',
    function ($scope, $filter, $sce, $timeout, DataService) {
        $scope.loading = true;
        $scope.filters = {};
        $scope.filterCommunes = {};
        $scope.predicate = 'name';
        $scope.reverse = false;

        $scope.disabled = undefined;

        $scope.enable = function() {
            $scope.disabled = false;
        };

        $scope.disable = function() {
            $scope.disabled = true;
        };

        $scope.order = function(predicate) {
            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
            $scope.predicate = predicate;
        };

        $scope.parent = {};
        $scope.parent.selected = undefined;
        $scope.clearFilters = function() {
            $scope.filter = undefined;
            $scope.searchText = '';
            $scope.parent = {};
            $scope.parentFilter = undefined;
        };

        $scope.category = {};
        $scope.loadList = function() {
            var cache = localStorage.getItem('hyperionIndicatorCategoryList')
            if(cache) {
                var data = JSON.parse(cache);
                $scope.setData(data);
            } else {
                DataService.categoryList()
                    .then(function (data) {
                        $scope.setData(data);
                    });
            }
        };

        $scope.setData = function(data) {
            $scope.categories = data['categories'];
            $scope.parents = data['parents'];

            $scope.loading = false;
        };
}]);

angular.module('List').filter('highlight', function($sce) {
    return function(text, phrase) {
        if (phrase && text) text = text.replace(new RegExp('('+phrase+')', 'gi'),
            '<span class="highlighted">$1</span>');

        return $sce.trustAsHtml(text)
    }
});

angular.module('List').filter('propsFilter', function() {
    return function(items, props) {
        var out = [];

        if (angular.isArray(items)) {
            items.forEach(function(item) {
                var itemMatches = false;

                var keys = Object.keys(props);
                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            out = items;
        }

        return out;
    }
});

angular.module('List').filter('categoryFilter', function() {
    return function(indicators, category) {
        if(indicators && indicators.length) {
            var result = {};
            angular.forEach(indicators, function(indicator, key) {
                if (indicator.category && indicator.category.uid in filterCommunes) {
                    result[key] = indicator;
                }
            });

            return result;
        } else {
            return indicators;
        }
    }
});
